var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-card-wrapper position-relative w-100 mb-1"},[_c('div',{staticClass:"vertical-line position-absolute",style:({
    background: _vm.places[_vm.place].colors.color
  })}),_c('div',{staticClass:"d-flex justify-content-between align-items-center h-100 text-white p-2 px-4",style:({
    background: _vm.places[_vm.place].colors.gradient,
  })},[_c('h5',{staticClass:"place-label text-right m-0"},[_vm._v(_vm._s(_vm.places[_vm.place].label))]),_c('h4',{staticClass:"place-prize text-uppercase m-0"},[_vm._v(_vm._s(_vm.prizeAmount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }